import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { useAppSelector } from "@/hooks/useAppSelector";
import { Office } from "@/api/offices";
import { useMemo } from "react";

interface FilteredOfficeHandbookProps extends AutocompleteProps<Office> {
  excludeOfficeIds: number[];
}

export function FilteredOfficeHandbook({
  excludeOfficeIds,
  ...props
}: FilteredOfficeHandbookProps) {
  const allOffices = useAppSelector((state) => state.handbooks.office);

  const filteredOffices = useMemo(() => {
    return allOffices
      .filter((office) => !excludeOfficeIds.includes(office.id))
      .map((item) => ({
        ...item,
        display_name: `${item.location_display_name} - ${item.display_name}`,
      }))
      .sort((a, b) => a.display_name.localeCompare(b.display_name));
  }, [allOffices, excludeOfficeIds]);

  return (
    <Autocomplete
      defaultItems={filteredOffices}
      label="Офис"
      placeholder="Выберите офис"
      variant="bordered"
      {...props}>
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}
